import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class WordListAnim {
    constructor() {
        this.wordListItems = gsap.utils.toArray(".word-list_item");

        if (this.wordListItems.length > 0) {
            this.init();
        }
    }

    init() {
        gsap.fromTo(
            this.wordListItems,
            { opacity: 0 },
            {
                opacity: 1,
                duration: 1,
                ease: "power3.out",
                stagger: 0.2,
                scrollTrigger: {
                    trigger: ".word-list",
                    start: "top 90%",
                    end: "top 50%",
                    scrub: 0.5,
                    once: true,
                },
            }
        );
    }
}
